import Breadcrumbs from "./breadcrumbs.vue";

const promise = new Promise(resolve => {
  vueApp.component('breadcrumbs', Breadcrumbs);
  resolve();
});

window.pendingComponentLoads.push(promise);